import { FunctionDeclaration, SchemaType } from "@google/generative-ai";
import { ToolHandler } from "./types";
import { ToolCall } from "../multimodal-live-types";
import { MultimodalLiveClient } from "../lib/multimodal-live-client";

export const webhookToolDeclaration: FunctionDeclaration = {
  name: "send_webhook",
  description: "Sends data to a webhook endpoint.",
  parameters: {
    type: SchemaType.OBJECT,
    properties: {
      url: {
        type: SchemaType.STRING,
        description: "The webhook URL to send data to",
      },
      data: {
        type: SchemaType.STRING,
        description: "JSON STRING data to send in the webhook payload",
      },
    },
    required: ["url", "data"],
  },
};

export class WebhookTool implements ToolHandler {
  name = "send_webhook";
  declaration = webhookToolDeclaration;

  async handleToolCall(toolCall: ToolCall, client: MultimodalLiveClient): Promise<void> {
    console.log(`Handling webhook tool call`, toolCall);
    
    // With the updated ToolRegistry, toolCall will only contain the relevant functionCall
    const functionCall = toolCall.functionCalls[0];
    
    if (functionCall && functionCall.name === this.name) {
      try {
        const { url, data } = functionCall.args as { url: string; data: string };
        
        // Send webhook
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: data,
        });
        
        const responseData = await response.json();
        
        // Send response back to the client
        client.sendToolResponse({
          functionResponses: [{
            response: { output: { success: true, response: responseData } },
            id: functionCall.id,
          }],
        });
      } catch (error) {
        console.error('Webhook error:', error);
        
        // Send error response back to the client
        client.sendToolResponse({
          functionResponses: [{
            response: { output: { success: false, error: (error as Error).message } },
            id: functionCall.id,
          }],
        });
      }
    }
  }
}
